import { MMM_DEMO_DASHBOARD_PATH } from '#mmm/utils'
import { FORGD_SYSTEM_PROJECT_ID } from '@forgd/shared/constants'

/**
 * Guest gate for the MMM V2 pre-activation experience.
 *
 * - Logged-in users always pass through (the project-id global middleware has
 *   already rewritten plain URLs to their `/project/:projectId` variant).
 * - Guests may access MMM on the public unscoped route, or on the system demo
 *   project (`FORGD_SYSTEM_PROJECT_ID`) for legacy links.
 * - Guests with another project's id in the URL are redirected to login.
 */
export default defineNuxtRouteMiddleware(async (to) => {
  const urlProjectId = Array.isArray(to.params.projectId)
    ? to.params.projectId[0]
    : to.params.projectId

  if (urlProjectId === FORGD_SYSTEM_PROJECT_ID && to.path.endsWith(MMM_DEMO_DASHBOARD_PATH)) {
    return navigateTo(
      { path: MMM_DEMO_DASHBOARD_PATH, query: to.query, hash: to.hash },
      { redirectCode: 301, replace: true },
    )
  }

  if (import.meta.server) {
    return
  }

  const auth = useAuth()

  await auth.waitForAuth({ from: 'mmm-v2-pre-activation middleware' })

  if (auth.isLoggedIn) {
    return
  }

  if (urlProjectId && urlProjectId !== FORGD_SYSTEM_PROJECT_ID) {
    auth.setRedirectTo(to.fullPath)
    return navigateTo('/login')
  }
})
